import IconHeartPin from '/app/assets/images/icons/heartpin.svg'
import React from 'react'
import styles from './styles.module.css'
import { CodonationReasons } from '../codonation_reasons/codonation_reasons'
import { CodonationSelection } from '../codonation_selection/codonation_selection'
import { Config, Display, FormValues } from 'donate/types'
import { FormikContextType } from 'formik'
import { I18nHtml } from 'shared'
export const CodonationBox = ({
  config,
  display,
  formik,
}: {
  config: Config
  display: Display
  formik: FormikContextType<FormValues>
}) => {
  if (config.showCodonation === false) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.iconWrapper}>
          <img src={IconHeartPin} alt="" className={styles.icon} />
        </div>
        <span className={styles.headline}>{i18n.t('donate.codonation_box.headline')}</span>
        <I18nHtml className={styles.subline} i18nKey="donate.codonation_box.subline_html" />
        <CodonationReasons />
        <CodonationSelection config={config} display={display} formik={formik} />
      </div>
    </div>
  )
}
